import "./Styles/listing-users.scss";
import "react-toggle/style.css";

import config from "../../app.json";
import axios from "axios";
import Pagination from "../../Components/Pagination/pagination";

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Button } from "react-bootstrap";
import AlertComponent from "../../Components/AlertComponent";
import VolunteerCard from "../../Components/VolunteerCard/volunteer-card";

function ListingUsers() {
  let navigate = useNavigate();

  const [userList, setUserList] = useState([]);

  const [currentPage, setCurrentPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const itemsPerPage = 12;

  const fetchUsers = () => {
    axios
      .post(config.API + "/api/User/getUsers", { 
        page: currentPage,
        perPage: itemsPerPage,
       })
      .then((res) => {
        if (res.status === 200 && res.data) {

          if (res.data.values.$values.length) {
            setTotalItems(res.data.total);
          } else {
            setTotalItems(0);
          }

          setUserList(res.data.values.$values);
        }
      })
      .catch(function (error) {
        return AlertComponent(
          "Error",
          error?.response?.data?.error ||
            error?.response?.data?.message ||
            error?.message,
          { icon: `error` }
        );
      });
  };

  useEffect(() => {
    fetchUsers();
  }, [0]);

  const handleNewUser = () => {
    return navigate("/users/new", { replace: false });
  };

  useEffect(() => {
    const totalPagesCalculated = Math.ceil(totalItems / itemsPerPage);
    setTotalPages(totalPagesCalculated);
  }, [totalItems]);

  useEffect(() => {
    fetchUsers();
  }, [currentPage]);

  const nextPage = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  const prevPage = () => {
    setCurrentPage((prevPage) => prevPage - 1);
  };

  const paginationElement = userList && userList.length ? (
    <div className="pagination-container">
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onNextPage={nextPage}
        onPrevPage={prevPage}
      />
    </div>
  ) : null;

  return (
    <Row>
      <Col className="col-md-11">
        <Row>
          <Col className="col-md-12 mb-3 mt-4">
            <Button className="add-new-btn" onClick={handleNewUser}>Add new</Button>
          </Col>
        </Row>
        <Row className="listing-users-container">
          {userList?.map((x) => (
            <Col className="mb-4" md={4}>
              <VolunteerCard {...x} />
            </Col>
          ))}
          {(!userList || !userList.length) && <p>There are no registered users.</p>}
          {paginationElement}
        </Row>
      </Col>
    </Row>
  );
}

export default ListingUsers;
